import { useAtom, useAtomValue } from "jotai";
import {
  projectNameAtom,
  softSkillsAtom,
  toolsExperienceAtom,
  projectTypeAtom,
  offeredGratificationAtom,
  requiredAreaOfExpertiseAtom,
  toolsExperienceOptionViewsAtom,
  forGratificationAtom,
  productTypeAtom,
} from "../pages/Projects/atoms/AddProjectAtomPage1";

import {
  projectDeadlineAtom,
  hardSkillsAtom,
  offeredWorkingTypeActiveOptionsAtom,
  descriptionAtom
} from "../pages/Projects/atoms/AddProjectAtomPage2";

import {
  usedLanguagesAtom,
  bizOrTechRoleAtomLeftValue,
  bizOrTechRoleAtomRightValue,
  requiredAvailabilityAtomStartValue,
  requiredAvailabilityAtomEndValue,
  requiredAvailabilityAtomOption,
  locationsAtom,
} from "../pages/Projects/atoms/AddProjectAtomPage3";

interface reqBody {
  softSkills?: string[];
  areaOfExpertise?: string[];
  toolsExperience?: any;
  hardSkills?: string[];
  offeredGratification?: string[];
  forGratification?: string[];
  projectName?: string;
  projectType?: string[];
  deadline?: Date;
  bizRole?: number;
  techRole?: number;
  availabilityFrom?: number;
  availabilityTo?: number;
  availabilityType?: string;
  workingTypeOffice?: boolean;
  workingTypeRemote?: boolean;
  usedLanguages?: string[];
  description?: string;
  locations?: string[];
  productType?: string[];
}

const useDataFromAddProjects = (): reqBody => {
  const projectName = useAtomValue(projectNameAtom);
  const softSkills = useAtomValue(softSkillsAtom);
  const toolsExperience = useAtomValue(toolsExperienceAtom);
  const projectType = useAtomValue(projectTypeAtom);
  const offeredGratification = useAtomValue(offeredGratificationAtom);
  const forGratification = useAtomValue(forGratificationAtom);
  const requiredAreaOfExpertise = useAtomValue(requiredAreaOfExpertiseAtom);
  const toolsExperienceOptionViews = useAtomValue(
    toolsExperienceOptionViewsAtom,
  ); // months!
  const projectDeadline = useAtomValue(projectDeadlineAtom);
  const hardSkills = useAtomValue(hardSkillsAtom);
  const offeredWorkingTypeActiveOptions = useAtomValue(
    offeredWorkingTypeActiveOptionsAtom,
  );
  const usedLanguages = useAtomValue(usedLanguagesAtom);
  const bizOrTechRoleLeftValue = useAtomValue(bizOrTechRoleAtomLeftValue);
  const bizOrTechRoleRightValue = useAtomValue(bizOrTechRoleAtomRightValue);
  const requiredAvailabilityStartValue = useAtomValue(
    requiredAvailabilityAtomStartValue,
  );
  const requiredAvailabilityEndValue = useAtomValue(
    requiredAvailabilityAtomEndValue,
  );
  const requiredAvailabilityOption = useAtomValue(
    requiredAvailabilityAtomOption,
  );
  const locations = useAtomValue(locationsAtom);
  const description = useAtomValue(descriptionAtom);
  const productType = useAtomValue(productTypeAtom);

  let body: reqBody = {};
  body.productType = productType;
  body.projectName = projectName;
  body.softSkills = softSkills;
  body.toolsExperience = [];
  body.projectType = projectType;
  body.offeredGratification = offeredGratification;
  body.forGratification = forGratification;
  body.areaOfExpertise = requiredAreaOfExpertise;
  body.deadline = projectDeadline;
  body.hardSkills = hardSkills;
  body.workingTypeRemote = offeredWorkingTypeActiveOptions[0];
  body.workingTypeOffice = offeredWorkingTypeActiveOptions[1];
  body.usedLanguages = usedLanguages;
  body.bizRole =
    bizOrTechRoleLeftValue == "" ? 50 : parseInt(bizOrTechRoleLeftValue);
  body.techRole =
    bizOrTechRoleRightValue == "" ? 50 : parseInt(bizOrTechRoleRightValue);
  body.availability = requiredAvailabilityStartValue;
  body.locations = locations;
  body.description = description;

  const keys = Object.keys(body);
  for (const key of keys) {
    if (!body[key as keyof reqBody]) {
      delete body[key as keyof reqBody];
    }
  } // is array empty we can do sth like that

  for (const tool of toolsExperience) {
    body.toolsExperience.push({
      tool: tool,
      mep: toolsExperienceOptionViews[tool],
    });
  }

  return body;
};

export { useDataFromAddProjects };
